import {
  Alert,
  AlertAction,
  AlertDescription,
  AlertTitle,
} from '@/components/ui/alert'
import { Button } from '@/components/ui/button'
import { useTranslation } from 'react-i18next'
import type { HazardGenerationSkippedItem } from './parseHazardGenerationSkippedItems'

type HazardGenerationSkippedSummaryAlertProps = {
  skippedItems: HazardGenerationSkippedItem[]
  onDismiss: () => void
}

export function HazardGenerationSkippedSummaryAlert({
  skippedItems,
  onDismiss,
}: HazardGenerationSkippedSummaryAlertProps) {
  const { t } = useTranslation('machineryDirectiveCompliance')

  if (skippedItems.length === 0) {
    return null
  }

  return (
    <Alert variant='info' className='mb-4'>
      <AlertTitle>
        {t('hazardsPage.skippedSummaryTitle', {
          count: skippedItems.length,
        })}
      </AlertTitle>
      <AlertDescription>
        <ul className='mt-2 list-disc space-y-2 pl-5'>
          {skippedItems.map((item, index) => (
            <li
              key={`${item.significantHazardId}:${item.name}:${String(index)}`}
            >
              <span className='font-medium text-foreground'>{item.name}</span>
              {item.reason.trim().length > 0 && (
                <span className='text-muted-foreground'>: {item.reason}</span>
              )}
            </li>
          ))}
        </ul>
      </AlertDescription>
      <AlertAction>
        <Button type='button' variant='outline' size='sm' onClick={onDismiss}>
          {t('hazardsPage.skippedSummaryDismiss')}
        </Button>
      </AlertAction>
    </Alert>
  )
}
